import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "36px 0 48px",
  overflow: "hidden",

  "& .attractions-swiper": {
    width: "100%",
    overflow: "visible",
    paddingBottom: "36px !important",

    "& .swiper-pagination-bullet": {
      backgroundColor: theme.palette.borderDefault,
      opacity: 1,
    },

    "& .swiper-pagination-bullet-active": {
      backgroundColor: theme.palette.primary,
    },
  },
}));

export const Title = styled("h2")(({ theme }) => ({
  fontSize: 22,
  fontWeight: 700,
  color: theme.palette.textPrimary,
  margin: "0 0 20px",
}));

export const Card = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  background: theme.palette.white,
  border: `1px solid ${theme.palette.borderLight}`,
  borderRadius: 14,
  padding: "20px 18px 16px",
  minHeight: 220,
  height: "100%",
  boxSizing: "border-box",
  transition: "all 0.25s ease",

  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: `0 10px 28px ${theme.palette.shadowSm}`,
    borderColor: theme.palette.primaryBorder,
  },
}));

export const CardEmoji = styled("div")({
  fontSize: "2.2rem",
  lineHeight: 1,
  marginBottom: 12,
});

export const CardName = styled("div")(({ theme }) => ({
  fontSize: 15,
  fontWeight: 700,
  color: theme.palette.textPrimary,
  marginBottom: 6,
}));

export const CardDesc = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.textSecondary,
  lineHeight: 1.55,
  flex: 1,
}));

export const CardRegion = styled("div")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  marginTop: 12,
  fontSize: 11,
  fontWeight: 600,
  color: theme.palette.primary,
  background: theme.palette.primarySubtle,
  padding: "3px 10px",
  borderRadius: 20,
  alignSelf: "flex-start",
}));
